import { useObservable } from '@/shared/hooks/useObservable';
import { mapLayersService } from '../services/map-layers.service';

export function KmlLayerControl() {
  const layers = useObservable(mapLayersService.layers$, []);
  const visible = useObservable(mapLayersService.visible$, {});

  const activeLayers = layers.filter(l => l.has_file);
  if (activeLayers.length === 0) return null;

  return (
    <div className="absolute bottom-4 left-4 z-[500] bg-slate-900/90 border border-slate-700 rounded-lg px-3 py-2 shadow-lg min-w-[140px]">
      <div className="text-xs text-slate-400 mb-1.5 font-semibold uppercase tracking-wide">
        Layers / Sloji
      </div>
      {activeLayers.map(layer => (
        <label
          key={layer.id}
          className="flex items-center gap-2 text-sm text-slate-200 cursor-pointer py-0.5 hover:text-white"
        >
          <input
            type="checkbox"
            checked={visible[layer.id] ?? true}
            onChange={() => mapLayersService.toggle(layer.id)}
            className="accent-blue-500"
          />
          {layer.name}
        </label>
      ))}
    </div>
  );
}
